// extracted by mini-css-extract-plugin
module.exports = {"player":"player--3WATSv","embed":"embed--2AjVAQ"};